// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Types
import type { ChartType } from '@/lib/analytics/charts/type';
import { SIZE_50 } from '@/lib/gridElements/size';
import { FACEBOOK } from '@/lib/socialProfile';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const followersHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.facebook.followers_history',
    margin: { left: -10, right: 25 },
    name: {
        date: 'date',
        evolution: 'evolution',
        value: 'chart.facebook.followers_history_name'
    },
    id: 'followers_history',
    social: FACEBOOK,
    color: {
        value: 'blue'
    },
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: 'chart.facebook.followers_history_tooltip',
    size: SIZE_50,
    type: 'chart',
    isXAxisDate: true,
    element: LineChart
};
